import React from "react";

const About = () => {
  return (
    <div className="about_container" id="about">
      <div className="about_info">
        <img className="about_left" src="https://media.istockphoto.com/id/1241710727/vector/working-at-home-vector-flat-style-illustration-online-career-coworking-space-illustration.jpg?s=170667a&w=0&k=20&c=LUG_C1Mir899A3KDstyWOyaivas1rC_c2SHL_SJkbLw="/>
        <div className="about_right">
          <div className="about_heading">ABOUT ME</div>
          <div className="about_heading_info">
            A dedicated Front-end Developer based in Hyderabad, India 📍
          </div>
          <div className="about_heading_brief">
            As a Front-End Developer. I possess an impressive arsenal of skills in HTML, CSS, Javascript, React and Redux. I excel in designing and maintaining single page web apps that offer smooth user experience. My expertise lies in crafting dynamic, enganging interfaces through writing clean, reusable and optimized code by utilizing cutting-edge development tools, techniques and best practices. I am also a team player who thrives in collaborating with cross-functional teams to produce outstanding web applications.
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
